// extracted by mini-css-extract-plugin
module.exports = {"box":"Error_box__6jaT5","inner":"Error_inner__Ll5Nc"};